import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const MailHeartOpen = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m3.5 20.5 7.993-4.5c.31-.179.705-.179 1.014 0l7.993 4.5m-17-8.907 7.442 4.1c.33.182.68-.068 1.058-.068.377 0 .727.25 1.058.068l7.442-4.1M17.5 10V5a1 1 0 0 0-1-1h-9a1 1 0 0 0-1 1v5m11 0c0 .552-.052 1 .5 1h2a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h1.5c1 0 1 0 1-1m11 0v3m-11-3v3m6.94-6c-.31 0-.61.09-.867.258a1.53 1.53 0 0 0-.573.684 1.53 1.53 0 0 0-.574-.684A1.6 1.6 0 0 0 10.558 7a1.72 1.72 0 0 0-1.117.54c-.289.31-.446.715-.44 1.134C9 10.508 11.6 12 12 12s3-1.492 3-3.326a1.64 1.64 0 0 0-.442-1.136c-.29-.31-.69-.503-1.118-.538"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(MailHeartOpen) as SvgIcon;
export { ForwardRef as ReactComponent };
